/**
 * @Author: tom
 * @Date:   2017-11-20T00:11:45+01:00
  @Last modified by:   tom
  @Last modified time: 2019-06-12T16:52:20+02:00

The Vue build version to load with the `import` command
(runtime-only or stand alone) has been set in webpack.base.conf with an alias.

**/
// important to start with this https://github.com/GoogleChrome/lighthouse/issues/9165#issuecomment-500445331
import './registerServiceWorker'

import Vue from 'vue'
// RESOURCES for POST/GET
import VueResource from 'vue-resource'
// Templating
import BootstrapVue from 'bootstrap-vue'

// import Conf from '@/config/settings'

import App from './App'
import router from './router'
import store from './store'

// Language and locales
import i18n from '@/lib/lang'

// using project defined icons
import './components/_shared/_icons'

// iframe embedder
import './components/_shared/_page_embed.js'
import './components/_shared/_page_embed.scss'
// using lazy image handler
import './components/_shared/_lazy-image.js'

// filters & mixins
import Filters from '@/lib/filters'
import Mixins from '@/lib/mixins'

// Analytics
// import VueAnalytics from 'vue-analytics'

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(Filters)
Vue.use(Mixins)
// Vue.config.productionTip = false // to log to console info that we are in dev mode

// https://github.com/MatteoGabriele/vue-analytics
// Vue.use(VueAnalytics, {
//   id: Conf.google.analytics.id,
//   router: router
//   // debug: {
//   //   enabled: true,
//   //   trace: false,
//   //   sendHitTask: true
//   // }
// })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
